import React from "react";

export interface RoomReservationStatusRenderProps {
    status: string;
}

export function RoomReservationStatusRender(props: RoomReservationStatusRenderProps) {
    switch (props.status) {
        case "reserva":
            return <>OK</>;
        case "cancelada":
            return <>CXL</>;
        case "prereserva":
        case "reactivation":
        default:
            return <>PEND</>;
    }
}
